import type { ReactNode } from 'react';
import { StatsigProvider } from '@statsig/react-bindings';

import { getStatsigClient } from '@/services/featureFlags';

type Props = { children: ReactNode };

export const FeatureFlagProvider = ({ children }: Props): JSX.Element => {
  const client = getStatsigClient();
  if (!client) return <>{children}</>;
  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};
